<style lang="scss">
.stat-card {
  &.pointer {
    transition: background-color 0.2s ease;
    &:hover {
      //box-shadow: 0 4px 24px 0 rgba(109, 157, 200, 0.4);
      background-color: rgba(173, 216, 230, 0.4);
    }
  }
}

.dark-layout {
  .stat-card {
    &.dark-mode-bg {
      transition: background-color 0.2s ease;
      box-shadow: 1px 1px 24px 0 rgba(109, 157, 200, 0.4);

      &:hover {
        background-color: rgba(115, 103, 240, 0.1) !important;
      }
    }
  }
}
</style>

<!-- eslint-disable -->
<template>
  <b-card
    class="text-center stat-card dark-mode-bg" @click="navigateTo(route)" :class="{'pointer': route}" v-b-tooltip.v-info="tooltip">
    <b-avatar
      class="mb-1"
      :variant="`light-${color}`"
      size="45"
    >
      <i v-if="fontAwesome" :class="fontAwesome" style="font-size: 21px"></i>
      <feather-icon v-else
        size="21"
        :icon="icon"
      />
    </b-avatar>
    <div class="truncate">
      <h2 class="mb-25 font-weight-bolder" :cy="statisticTitle">
        {{ statistic }}
      </h2>
      <span>{{ statisticTitle }}</span>
    </div>
  </b-card>
</template>
<!-- eslint-enable -->

<script>
  export default {
    components: {},
    props: {
      icon: {
        type: String,
        required: false,
        default: '',
      },
      statistic: {
        type: [Number, String],
        required: false,
      },
      statisticTitle: {
        type: String,
        default: '',
      },
      color: {
        type: String,
        default: 'primary',
      },
      route: {
        type: String,
        default: '',
        required: false,
      },
      tooltip: {
        type: String,
        default: '',
        required: false,
      },
      fontAwesome: {
        type: String,
        default: '',
        required: false,
      },
    },
    data() {
      return {
        test: '',
      };
    },
    mounted() {

    },
    methods: {
      navigateTo(route) {
        if (route) {
          this.$router.push({ name: route });
        }
      },
    },
  };
</script>
